<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/lp/msc_seminar_2023_heddar_3.jpg" class="only_pc" />
        <img src="@/assets/img/lp/msc_seminar_2023_heddar_3.jpg" class="only_sp" />
      </div>
    </div>
  </section>

  <section class="msc_seminar mt-5">
    <p class="mt-5 mb-5 p-3 d-flex justify-content-around">
      <span class="d-flex justify-content-center align-items-center" style="font-size: 2.5rem;">全会場とも</span>
      <span class="d-flex justify-content-center">
        【受付開始】12:30〜<br>
        【開催時間】13:00〜15:30（予定）<br>
        ※各会場によりプログラムが若干異なる場合もございます。<br>
        &emsp;よって終了時間も変更となる場合がございます。
      </span>
    </p>
    <div class="only_pc">
      <table class="seminar_table w-100">
        <thead>
          <tr>
            <th style="width: 100px;">日付</th>
            <th colspan="2">開催地域</th>
            <th>会場</th>
            <th style="width: 150px;"></th>
          </tr>
        </thead>
        <tbody>
          <!-- PC:佐世保 -->
          <tr>
            <td class="text-center">5/12（日）</td>
            <td class="text-center"><a href="https://www.jrhtb.hotelokura.co.jp/access/"><img src="@/assets/img/lp/sasebo_okura.jpg" alt="長崎" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐世保</td>
            <td>
              ホテルオークラJRハウステンボス [鳳の間]<br>
              定員数：50名様<br>
              長崎県佐世保市ハウステンボス町10番<br>
              0956-58-7111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC:佐世保ここまで -->

          <!-- PC：久留米 -->
          <tr>
            <td class="text-center">5/21（火）</td>
            <td class="text-center"><a href="https://www.hotelsousei.jp/kurume/access/"><img src="@/assets/img/lp/kurume.jpg" alt="久留米" style="width: 150px;"></a></td>
            <td style="width: 70px;">久留米</td>
            <td>
              ホテルマリターレ創世 久留米 [フローラ]<br>
              定員数：50名様<br>
              福岡県久留米市東櫛原町900<br>
              0942-35-3511
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：久留米ここまで -->
          
          <!-- PC：大阪 -->
          <tr>
            <td class="text-center">7/1（月）</td>
            <td class="text-center"><a href="https://www.granvia-osaka.jp/access/"><img src="@/assets/img/lp/oosaka_2.jpg" alt="大阪" style="width: 150px;"></a></td>
            <td style="width: 70px;">大阪</td>
            <td>
              ホテルグランヴィア大阪 [名庭]<br>
              定員数：100名様<br>
              大阪市北区梅田3丁目1番1号(フロント19階)<br>
              0570-06-1235
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：大阪ここまで -->
          
          <!-- PC：宮崎 -->
          <tr>
            <td class="text-center">7/13（土）</td>
            <td class="text-center"><a href="https://www.miyakan-h.com/outline/access.html"><img src="@/assets/img/lp/miyazaki.jpg" alt="宮崎" style="width: 150px;"></a></td>
            <td style="width: 70px;">宮崎</td>
            <td>
              宮崎観光ホテル 東館３階 [碧翠燿]<br>
              定員数：100名様<br>
              宮崎県宮崎市松山1-1-1<br>
              0985-27-1212
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：宮崎ここまで -->

          <!-- PC：大村 -->
          <tr>
            <td class="text-center">7/22（月）</td>
            <td class="text-center"><a href="https://parkbells.net/access/"><img src="@/assets/img/lp/nagasaki_oomura.jpg" alt="大村" style="width: 150px;"></a></td>
            <td style="width: 70px;">大村</td>
            <td>
              パークベルズ大村 [デュークホール]<br>
              定員数：70名様<br>
              長崎県大村市幸町25-30<br>
              0957-54-3131
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：大村ここまで -->
          
          <!-- PC：延岡 -->
          <tr>
            <td class="text-center">9/7（土）</td>
            <td class="text-center"><a href="https://www.encity-h.com/access/"><img src="@/assets/img/lp/nobeoka.jpg" alt="延岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">延岡</td>
            <td>
              エンシティホテル延岡 [山水]<br>
              定員数：50名様<br>
              宮崎県延岡市紺屋町1丁目4-28<br>
              0982-32-6060
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <!-- PC：延岡ここまで -->

          <!-- PC:大宮 -->
          <!-- <tr>
            <td class="text-center">3/19（火）</td>
            <td class="text-center"><a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a></td>
            <td style="width: 70px;">大宮</td>
            <td>
              パレスホテル大宮 [チェリールーム]<br>
              定員数：100名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:大宮ここまで -->
          
          <!-- PC:宮城 -->
          <!-- <tr>
            <td class="text-center">3/28（木）</td>
            <td class="text-center"><a href="https://east-sendai.metropolitan.jp/access/index.html"><img src="@/assets/img/lp/sendai.jpg" alt="宮城" style="width: 150px;"></a></td>
            <td style="width: 70px;">宮城</td>
            <td>
              ホテルメトロポリタン仙台 [星雲]<br>
              定員数：50名様<br>
              宮城県仙台市青葉区中央1-1-1<br>
              022-268-2525
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:宮城ここまで -->

          <!-- PC：札幌 -->
          <!-- <tr>
            <td class="text-center">11/20（月）</td>
            <td class="text-center"><a href="https://newotanisapporo.com/access/"><img src="@/assets/img/lp/sapporo.jpg" alt="札幌" style="width: 150px;"></a></td>
            <td style="width: 70px;">札幌</td>
            <td>
              ニューオータニイン札幌 [北斗の間]<br>
              定員数：50名様<br>
              北海道札幌市中央区2条西1丁目1-1<br>
              011-222-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr> -->
          <!-- PC：札幌ここまで -->

          <!-- PC：佐世保 -->
          <!-- <tr>
            <td class="text-center">7/1（土）</td>
            <td class="text-center"><a href="https://www.jrhtb.hotelokura.co.jp/access/"><img src="@/assets/img/lp/sasebo_okura.jpg" alt="佐世保" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐世保</td>
            <td>
              ホテルオークラJRハウステンボス [鳳の間]<br>
              定員数：100名様<br>
              長崎県佐世保市ハウステンボス町10番<br>
              0956-58-7111
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr> -->
          <!-- PC:佐世保ここまで -->

          <!-- PC:佐野 -->
          <!-- <tr>
            <td class="text-center">7/2（日）</td>
            <td class="text-center"><a href="https://sunroute-sano.com/access.html"><img src="@/assets/img/lp/sano_sunroot.jpg" alt="佐野" style="width: 150px;"></a></td>
            <td style="width: 70px;">佐野</td>
            <td>
              ホテルサンルート佐野 [平安西]<br>
              定員数：50名様<br>
              栃木県佐野市朝日町702-27<br>
              0283-24-5000
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr> -->
          <!-- PC:佐野ここまで -->
          
          <!-- PC:福岡 -->
          <!-- <tr>
            <td class="text-center">7/21（金）</td>
            <td class="text-center"><a href="https://www.hotelnikko-fukuoka.com/access/"><img src="@/assets/img/lp/fukuoka_nikkou.jpg" alt="福岡" style="width: 150px;"></a></td>
            <td style="width: 70px;">福岡</td>
            <td>
              ホテル日航福岡 [ラメール]<br>
              定員数：100名様<br>
              福岡市博多区博多駅前2丁目18番25号<br>
              092-482-1111
            </td>
            <td class="text-center"><img src="@/assets/img/lp/cancel.jpg" alt="中止" style="width: 100px;"></td>
          </tr> -->
          <!-- PC:福岡ここまで -->

          <!-- PC:浜松 -->
          <!-- <tr>
            <td class="text-center">6/7（水）</td>
            <td class="text-center"><a href="https://www.act-okura.co.jp/access/"><img src="@/assets/img/lp/hamamatsu_okura.jpg" alt="浜松" style="width: 150px;"></a></td>
            <td style="width: 70px;">浜松</td>
            <td>
              オークラアクトシティホテル浜松 [チェルシー]<br>
              定員数：50名様<br>
              静岡県浜松市中区板屋町111-2<br>
              053-459-0111
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr> -->
          <!-- PC:浜松ここまで -->          

        </tbody>
      </table>
    </div>
    
    <div class="only_sp">
      <!-- SP:佐世保 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">5/12（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.jrhtb.hotelokura.co.jp/access/"><img src="@/assets/img/lp/sasebo_okura.jpg" alt="佐世保" style="width: 150px;"></a><br>
              <span>佐世保</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルオークラJRハウステンボス [鳳の間]<br>
              定員数：50名様<br>
              長崎県佐世保市ハウステンボス町10番<br>
              0956-58-7111
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:佐世保ここまで -->
      
      <!-- SP：久留米 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">5/21（火）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hotelsousei.jp/kurume/access/"><img src="@/assets/img/lp/kurume.jpg" alt="久留米" style="width: 150px;"></a><br>
              <span>久留米</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルマリターレ創世 久留米 [フローラ]<br>
              定員数：50名様<br>
              福岡県久留米市東櫛原町900<br>
              0942-35-3511
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:久留米ここまで -->
      
      <!-- SP：大阪 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/1（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.granvia-osaka.jp/access/"><img src="@/assets/img/lp/oosaka_2.jpg" alt="大阪" style="width: 150px;"></a><br>
              <span>大阪</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルグランヴィア大阪 [名庭]<br>
              定員数：100名様<br>
              大阪市北区梅田3丁目1番1号(フロント19階)<br>
              0570-06-1235
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:大阪ここまで -->
      
      <!-- SP：宮崎 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/13（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.miyakan-h.com/outline/access.html"><img src="@/assets/img/lp/miyazaki.jpg" alt="宮崎" style="width: 150px;"></a><br>
              <span>宮崎</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              宮崎観光ホテル 東館３階 [碧翠燿]<br>
              定員数：100名様<br>
              宮崎県宮崎市松山1-1-1<br>
              0985-27-1212
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:宮崎ここまで -->
      
      <!-- SP:大村 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/22（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://parkbells.net/sp/access/"><img src="@/assets/img/lp/nagasaki_oomura.jpg" alt="大村" style="width: 150px;"></a><br>
              <span>大村</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              パークベルズ大村 [デュークホール]<br>
              定員数：70名様<br>
              長崎県大村市幸町25-30<br>
              0957-54-3131
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:大村ここまで -->
      
      <!-- SP:延岡 -->
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">9/7（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.encity-h.com/access/"><img src="@/assets/img/lp/nobeoka.jpg" alt="延岡" style="width: 150px;"></a><br>
              <span>延岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              エンシティホテル延岡 [山水]<br>
              定員数：50名様<br>
              宮崎県延岡市紺屋町1丁目4-28<br>
              0982-32-6060
            </td>
          </tr>
        </tbody>
      </table>
      <!-- SP:大村ここまで -->
      
      <!-- SP:大宮 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">3/19（火）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.palace-omiya.co.jp/access/"><img src="@/assets/img/lp/oomiya.jpg" alt="大宮" style="width: 150px;"></a><br>
              <span>大宮</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              パレスホテル大宮 [チェリールーム]<br>
              定員数：100名様<br>
              埼玉県さいたま市大宮区桜木町1-7-5<br>
              048-647-3300
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:大宮ここまで -->
      
      <!-- SP:仙台 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">3/28（木）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://sendai.metropolitan.jp/access/index.html"><img src="@/assets/img/lp/sendai.jpg" alt="仙台" style="width: 150px;"></a><br>
              <span>仙台</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルメトロポリタン仙台 [星雲]<br>
              定員数：50名様<br>
              宮城県仙台市青葉区中央1-1-1<br>
              0022-268-2525
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:仙台ここまで -->
      
      <!-- SP：札幌 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/20（月）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://newotanisapporo.com/access/"><img src="@/assets/img/lp/sapporo.jpg" alt="札幌" style="width: 150px;"></a><br>
              <span>札幌</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ニューオータニイン札幌 [北斗の間]<br>
              定員数：50名様<br>
              北海道札幌市中央区2条西1丁目1-1<br>
              011-222-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:札幌ここまで -->
            
      <!-- SP:佐野 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/2（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://sunroute-sano.com/access.html"><img src="@/assets/img/lp/sano_sunroot.jpg" alt="佐野" style="width: 150px;"></a><br>
              <span>佐野</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテルサンルート佐野 [平安西]<br>
              定員数：50名様<br>
              栃木県佐野市朝日町702-27<br>
              0283-24-5000
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:佐野ここまで -->
      
      <!-- SP:福岡 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">7/21（金）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.hotelnikko-fukuoka.com/access/"><img src="@/assets/img/lp/fukuoka_nikkou.jpg" alt="福岡" style="width: 150px;"></a><br>
              <span>福岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/cancel.jpg" alt="中止" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              ホテル日航福岡 [ラメール]<br>
              定員数：100名様<br>
              福岡市博多区博多駅前2丁目18番25号<br>
              092-482-1111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:福岡ここまで -->

      <!-- SP:浜松 -->
      <!-- <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">6/7（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.act-okura.co.jp/access/"><img src="@/assets/img/lp/hamamatsu_okura.jpg" alt="浜松" style="width: 150px;"></a><br>
              <span>浜松</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              オークラアクトシティホテル浜松 [チェルシー]<br>
              定員数：50名様<br>
              静岡県浜松市中区板屋町111-2<br>
              053-459-0111
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- SP:浜松ここまで -->

    </div>
  </section>

  <section class="msc_seminar mt-5">
    <div>
      <p class="text-center mt-5">
        限定数に達した時点で、受付は終了させていただきますので予めご了承ください。
      </p>
      <p class="text-center mt-3">
        ★各会場の案内板等でお部屋をご確認のうえ、お越しください。
      </p>
    </div>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">【ご参加の皆さまへ】</h3>
    <ul class="seminar_text_list list-dot-01">
      <li>日程に変更があった場合、メール、ホームページ等でお知らせいたします。</li>
      <li>マイクロバス等でご来場の場合、事前にご自身で駐車場の状況を会場側にご確認ください。</li>
      <li>入室の際には、アルコール消毒のご協力をお願いいたします。また、発熱等、体調が優れない場合にはご来場をお控えください。</li>
    </ul>

    <p class="text-center mt-5">ご質問やご不明な点などございましたら、会員サポート部までお問合せください。</p>
    <div class="d-flex justify-content-center align-items-center mt-5">
        <P>株式会社マナビス化粧品<br>会員サポート部</p>
        <img src="@/assets/img/lp/tel.png" alt="電話" class="mx-5">
        <p style="font-size: 3rem;">0120-268-510</p>
    </div>

  </section>
    



  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<!-- 化粧品公式サイトのスタイルを反映 -->
<style src="../../assets/css/custom.css" scoped>
</style>
<style src="../../assets/css/module.css" scoped>
</style>
<style src="../../assets/css/module_sp.css" scoped>
</style>
<style src="../../assets/css/top.css" scoped>
</style>

<style scoped>
.box-top-slide {
  height: initial;
}
.seminar_table thead {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  line-height: 50px;
}
.seminar_table th {
  font-weight: 300;
}
.seminar_table tbody tr {
  border-bottom: 1px solid #eee;
  height: 150px;
}
.seminar_table td {
  vertical-align: middle;
}
.seminar_table td:first-child {
  font-size: 24px;
}
.seminar_table td.w-100px {
  width: 100px;
}
.list_style_non li {
  list-style: none;
  margin-left: 0;
}
button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}

@media screen and (min-width: 1px) and (max-width: 699px) {
  .msc_seminar .d-flex {
    flex-direction: column;
  }
  .only_sp .seminar_table tr {
    height: initial;
  }
  .only_sp .seminar_table th {
    vertical-align: middle;
  }
  .only_sp .seminar_table td {
    padding: 10px 0 10px 20px;
  }
  .only_sp .seminar_table tr:first-child {
     border-top: 1px solid #eee;
  }
  .only_sp .seminar_table tr:first-child td {
    font-size: 24px;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>